import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { RECOMMENDATION_SOURCE, setRecommendations } from 'modules/recommendations';

export const useChatAgentUtils = () => {
    const dispatch = useDispatch();

    const setFormData = useCallback(
        formData => {
            dispatch(
                setRecommendations({
                    recommendationData: formData,
                    recommendationSource: RECOMMENDATION_SOURCE.CHAT_AGENT,
                })
            );
        },
        [dispatch]
    );
    return { setFormData };
};
